import { DOM } from '../shared/helpers/Document';

// i18n 
(function() {
	const sel = DOM.qsa('.i18n-selector');
	if( sel.length === 0 ) {
		return;
	}
	
	const className = 'open';
	sel.forEach(s => {
		const button = s.querySelector('.i18n-selector-toggle');
		button.addEventListener('click', () => s.classList.toggle(className) );
	});
}());